import { useEffect, useState } from "react";
import { fetchMagazines } from "./magazineApi";
import WordSpacedText from "../components/WordSpacedText";  // ✅ Make sure it's correctly exported

const MagazinePosts = () => {
  const [magazines, setMagazines] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadMagazines() {
      try {
        const response = await fetchMagazines();
        console.log("Fetched magazines:", response); // ✅ Add this
        setMagazines(response);
      } catch (error) {
        console.error("Failed to fetch magazines:", error);
      } finally {
        setLoading(false);
      }
    }

    loadMagazines();
  }, []);

  if (loading) return <p>Loading magazines...</p>;

  if (magazines.length === 0) return <p><WordSpacedText>No magazines found.</WordSpacedText></p>;

  return (
    <div>
      <WordSpacedText><h2>OurMagazines</h2></WordSpacedText>
      <WordSpacedText>{magazines.map((mag) => (
        <div key={mag.id}>
          <h3>{mag.name}</h3>
          <p>{mag.description}</p>
        </div>
      ))}</WordSpacedText>
    </div>
  );
};

export default MagazinePosts;
